import {DependencyInjectId} from '@@/package/const/DependencyInjectId';
import HttpClient from '@@/package/network/HttpClient';
import {type AxiosResponse} from 'axios';
import {type ApplicationContextInterface} from '@@/package/application/applicationContext';
import type {ContactModel} from "~~/package/mapper/contact/model/ContactModel";
import type CustomResponse from "~~/package/types/ResponseType";

export default class ContactApi {

    protected http: HttpClient;

    constructor(context: ApplicationContextInterface) {
        this.http = context.getService<HttpClient>(DependencyInjectId.HttpClient);
    }

    public submitContactData(request: ContactModel): Promise<AxiosResponse<CustomResponse<boolean>>> {
        return this.http.post<AxiosResponse<CustomResponse<boolean>>, ContactModel>('/contact-us', request, false);
    }
}
